import { Link } from 'react-router-dom'
import { ExternalLink } from 'lucide-react'

export function Footer() {
  return (
    <footer className="border-t border-white/5 bg-dark-bg-secondary/50">
      <div className="container mx-auto px-4 py-2 max-w-7xl">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-2 text-xs">
          <div className="text-center lg:text-left">
            <span className="text-gray-400">
              Developed by{' '}
              <a
                href="http://www.bi.a.u-tokyo.ac.jp/~tterada/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-accent-cyan hover:underline"
              >
                Tohru Terada
              </a>
              <sup>1</sup>, Ryota Kobayashi<sup>1</sup>, Koutaro Ukai<sup>1</sup>, Yoshitaka Moriwaki<sup>1,2</sup>, Chee Siang LEOW<sup>3</sup>, and Suguru Fujita<sup>1</sup>
            </span>
            <span className="text-gray-500 ml-2">
              (<sup>1</sup>The University of Tokyo, <sup>2</sup>Institute of Science Tokyo, <sup>3</sup>University of Yamanashi)
            </span>
          </div>

          <div className="flex items-center gap-3">
            <a
              href="https://mibig.secondarymetabolites.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-gray-400 hover:text-accent-cyan transition-colors"
            >
              MIBiG <ExternalLink className="w-2.5 h-2.5" />
            </a>
            <a
              href="https://www.uniprot.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-gray-400 hover:text-accent-cyan transition-colors"
            >
              UniProt <ExternalLink className="w-2.5 h-2.5" />
            </a>
            <a
              href="https://www.rhea-db.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-gray-400 hover:text-accent-cyan transition-colors"
            >
              Rhea <ExternalLink className="w-2.5 h-2.5" />
            </a>
            <span className="text-gray-500">|</span>
            <span className="text-gray-500">
              MIBiG v4.0, AlphaFold v4
            </span>
            <Link to="/data-sources" className="text-accent-cyan hover:underline">
              More
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
